export interface VehicleOption {
  value: string;
  isNew: boolean;
}

export function buildVehicleOptions(
  vehicles: string[],
  search: string
): VehicleOption[] {
  const trimmed = search.trim();
  const lower = trimmed.toLowerCase();

  const matches = trimmed
    ? vehicles.filter((v) => v.toLowerCase().includes(lower))
    : vehicles;
  const options: VehicleOption[] = matches.map((v) => ({
    value: v,
    isNew: false,
  }));

  const alreadyExists = vehicles.some((v) => v.toLowerCase() === lower);
  if (trimmed && !alreadyExists) {
    options.unshift({ value: trimmed, isNew: true });
  }

  return options;
}
